import { render, staticRenderFns } from "./EmailAddressSetting.vue?vue&type=template&id=f460dc76&scoped=true&"
import script from "./EmailAddressSetting.vue?vue&type=script&lang=ts&"
export * from "./EmailAddressSetting.vue?vue&type=script&lang=ts&"
import style0 from "./EmailAddressSetting.vue?vue&type=style&index=0&id=f460dc76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f460dc76",
  null
  
)

export default component.exports